import React from 'react';
import PropTypes from 'prop-types';
import { renderRoutes } from 'react-router-config';

import OnboardingLayout from '../../../apps/temp/views/onboarding/OnboardingLayout/OnboardingLayout';
import ScrollToTop from '../../../components/routing/ScrollToTop';

const propTypes = {
  route: PropTypes.object,
};

const JoinAlbumFolderMasterView = ({ route }) => {
  return (
    <OnboardingLayout>
      {renderRoutes(route.routes)}

      <ScrollToTop />
    </OnboardingLayout>
  );
};

JoinAlbumFolderMasterView.propTypes = propTypes;

export default JoinAlbumFolderMasterView;
